export class CnstContWIPCommitSaveParam
{
    insertUserId: any;
    personId: any;
}
